import connectedComponent from './ToolGroupButton';

export default connectedComponent;